/**
 * Greek (el) stems + options for NotAny seed MCQs.
 * English canonical text lives in `seed.ts`; `correctIndex` is unchanged.
 */
export const NOTANY_SEED_QUESTIONS_EL: Readonly<
  Record<string, { text: string; options: [string, string, string, string] }>
> = {
  na00: {
    text: "Τι κάνει το notanyai «προσαρμοστικό»;",
    options: [
      "Εμφανίζει κάθε ερώτηση με σταθερή σειρά",
      "Επιλέγει την επόμενη ερώτηση από το Elo σας, ένα γράφημα προγράμματος σπουδών και ένα μοντέλο κυριαρχίας ανά έννοια",
      "Επαναλαμβάνει ερωτήσεις μόνο σε ένα απλό χρονόμετρο",
      "Ανακατεύει τυχαία ένα σταθερό κουίζ",
    ],
  },
  na01: {
    text: "Όταν απαντάτε σωστά σε μια ερώτηση, το μοντέλο μαεστρίας του Notanyai…",
    options: [
      "Ξεχνάει το αποτέλεσμα μετά το τέλος της συνεδρίας",
      "Ενημερώνει μόνο αυτή την ερώτηση",
      "Αυξάνει την εμπιστοσύνη στις προαπαιτούμενες έννοιες στις οποίες βασίζεται επίσης",
      "Επαναφέρει τη βαθμολογία σας στην αρχική τιμή",
    ],
  },
  na02: {
    text: "Ποιοι αλγόριθμοι γραφημάτων βοηθούν τον Notanyai να αποφασίσει τι είναι πιο σημαντικό να διδάξει στη συνέχεια;",
    options: [
      "PageRank, HITS, μεταξύ και τοπολογική σειρά πάνω από το γράφημα του προγράμματος σπουδών",
      "Μια μοναδική γεννήτρια τυχαίων αριθμών",
      "Αλφαβητική ταξινόμηση ονομάτων εννοιών",
      "Οι έννοιες της παραγγελίας προστέθηκαν στη βάση δεδομένων",
    ],
  },
  na03: {
    text: "Τι σας δίνει το notanyai που δεν μπορεί ποτέ να γίνει ένα μεμονωμένο εκπαιδευτικό βίντεο;",
    options: [
      "Μεγαλύτερος χρόνος εκτέλεσης",
      "Μουσική φόντου",
      "Πιστοποιητικό ολοκλήρωσης χωρίς δοκιμές",
      "Ελεγχόμενα στοιχεία ανά ιδέα για το ποιος έχει κατακτήσει τι",
    ],
  },
  na04: {
    text: "Για έλεγχο της ικανότητας τεχνητής νοημοσύνης του προσωπικού, η notanyai μπορεί να δείξει…",
    options: [
      "Κατοχή ανά άτομο, ανά έννοια ως ερώτημα",
      "Μόνο ένας αριθμός βίντεο που παρακολουθήσατε",
      "Τίποτα — η μάθηση δεν μετριέται",
      "Ένα μόνο πέρασμα/αποτυχία σε επίπεδο οργανισμού χωρίς λεπτομέρειες",
    ],
  },
  na05: {
    text: "Εκτός από τον αλφαβητισμό AI, τι μπορεί να διδάξει ο notanyai;",
    options: [
      "Μόνο γλώσσες",
      "Μόνο πρώτες βοήθειες",
      "Οποιοδήποτε θέμα — οι εταιρείες δημιουργούν τη δική τους ομάδα εκπαιδεύσεων και δοκιμών",
      "Τίποτα άλλο? είναι μια ενιαία σταθερή πορεία",
    ],
  },
  na06: {
    text: "Πώς μια εταιρεία προσθέτει τη δική της εκπαίδευση στο notanyai;",
    options: [
      "Ξαναγράφοντας τη μηχανή για κάθε θέμα",
      "Με τη σύνταξη ενός SubjectPack — το περιεχόμενο είναι εντελώς ξεχωριστό από τον κινητήρα",
      "Στέλνοντας email στον πωλητή ένα PDF για φιλοξενία",
      "Δεν μπορεί. μόνο πλοία τεχνητής νοημοσύνης",
    ],
  },
  na07: {
    text: "«Ένας κινητήρας, πολλά SubjectPacks» σημαίνει ότι μια εταιρεία μπορεί να τρέξει…",
    options: [
      "Ενσωμάτωση, ασφάλεια, συμμόρφωση και εκπαίδευση προϊόντων σε ένα μέρος",
      "Ακριβώς ένα μάθημα, για πάντα",
      "Μόνο μαθήματα καταναλωτικής γλώσσας",
      "Ένα υπολογιστικό φύλλο με βαθμολογίες κουίζ",
    ],
  },
  na08: {
    text: "Όταν το notanyai φιλοξενείται από μόνος του, πού βρίσκονται τα δεδομένα των μαθητών σας;",
    options: [
      "Σε σύννεφο προμηθευτή SaaS τρίτου μέρους",
      "Στο σύννεφο της Google",
      "Στο δημόσιο διαδίκτυο",
      "Μέσα στο δικό σας cloud, VPC ή on-prem",
    ],
  },
  na09: {
    text: "Γιατί η αυτο-φιλοξενία έχει σημασία για τις ρυθμιζόμενες βιομηχανίες;",
    options: [
      "Κυριαρχία δεδομένων — ευαίσθητο περιεχόμενο δεν φεύγει ποτέ από την περίμετρό σας",
      "Κάνει την εφαρμογή να φορτώνει τις εικόνες πιο γρήγορα",
      "Καταργεί την ανάγκη για οποιονδήποτε έλεγχο ταυτότητας",
      "Επιτρέπει σε οποιονδήποτε να διαβάσει τις απαντήσεις άλλων μαθητών",
    ],
  },
  na10: {
    text: "Η στοίβα notanyai που φιλοξενείτε μόνοι σας είναι…",
    options: [
      "Ένα κλειστό δυαδικό που δεν μπορείτε να επιθεωρήσετε",
      "Μια στατική δέσμη διεπαφής συν ένα ανοιχτό σύστημα υποστήριξης Supabase",
      "Μια κεντρική συσκευή που αποστέλλεται ταχυδρομικώς",
      "Μόνο διακομιστής άδειας χρήσης ανά θέση",
    ],
  },
  na11: {
    text: "Ποιο είναι ένα χαρακτηριστικό απόρρητο ανά σχεδιασμό του notanyai;",
    options: [
      "Πώληση δεδομένων μαθητών σε διαφημιστές",
      "Αποθήκευση κωδικών πρόσβασης σε απλό κείμενο",
      "Ασφάλεια σε επίπεδο σειράς, ανώνυμη διατήρηση και διαγραφή αυτοεξυπηρέτησης",
      "Απαιτείται σύνδεση στα μέσα κοινωνικής δικτύωσης",
    ],
  },
  na12: {
    text: "Όταν ένας χρήστης διαγράφει τον λογαριασμό του, το ιστορικό πρακτικής του είναι…",
    options: [
      "Ανώνυμα για βαθμονόμηση, χωρίς σύνδεσμο πίσω σε αυτά",
      "Αποστέλλεται με email σε όλη την εταιρεία",
      "Διατηρήθηκε πλήρως αναγνωρίσιμη για πάντα",
      "Πωλείται σε μεσίτη δεδομένων",
    ],
  },
  na13: {
    text: "Τι κάνει τους μαθητές να επιστρέφουν στο notanyai;",
    options: [
      "Αναδυόμενες διαφημίσεις μεταξύ ερωτήσεων",
      "Καθημερινές σειρές, μίνι παιχνίδια, αποστολές και στυλ GameMaster",
      "Υποχρεωτικές εβδομαδιαίες συναντήσεις",
      "Ένα μεγάλο PDF για να ξαναδιαβαστεί",
    ],
  },
  na14: {
    text: 'Ένα "GameMaster style" επιτρέπει στον εκπαιδευόμενο να επιλέξει…',
    options: [
      "Μόνο το μέγεθος της γραμματοσειράς",
      "Ποιες διαφημίσεις βλέπουν",
      "Ένας διαφορετικός πωλητής",
      "Ένας ασθενής προπονητής, ένας λοχίας τρυπάνι ή μια ισορροπημένη προεπιλογή",
    ],
  },
  na15: {
    text: "Τι σημαίνει «χωρίς κλείδωμα» για το notanyai;",
    options: [
      "Καμία ιδιόκτητη μορφή περιεχομένου και καμία υποχρεωτική εξάρτηση φιλοξενίας",
      "Πρέπει να ανανεώνετε μια άδεια κάθε μήνα διαφορετικά θα χάσετε την πρόσβαση",
      "Το περιεχόμενο ανοίγει μόνο στο πρόγραμμα προβολής ενός προμηθευτή",
      "Η εξαγωγή των δεδομένων σας κοστίζει επιπλέον",
    ],
  },
  na16: {
    text: "Σε τι περίπου λειτουργεί μια ανάπτυξη παραγωγής notanyai;",
    options: [
      "Ένα ράφι αποκλειστικών διακομιστών GPU",
      "Ένα εξαψήφιο ετήσιο συμβόλαιο cloud",
      "Ένα μικρό ARM VM (περίπου 4 €/μήνα)",
      "Ένας προσωπικός φορητός υπολογιστής που πρέπει να παραμείνει ανοιχτός",
    ],
  },
};
